<template>
  <div>
    <div class="modal-header">
      <h2>Izmeni isplatu</h2>
    </div>
    <div class="body">
      <div class="input-wrapper">
        <div class="name--mod relative">
          <input
            type="text"
            class="form-control form-control-lg input--name"
            placeholder=" "
            v-model="transaction.description"
          />
          <span class="input-span input-span--name">Naziv</span>
        </div>
        <div class="amount--mod relative">
          <input
            type="text"
            class="form-control form-control-lg input--amount"
            placeholder=" "
            v-model.lazy="payoutAmount"
            v-money="{}"
          />
          <span class="input-span input-span--amount">Iznos</span>
        </div>
      </div>
    </div>
    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>
      <div class="buttons">
        <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">Otkaži</button>
        <button type="submit" class="btn btn-primary btn--mod" @click="edit" :disabled="loading">
          <p v-if="!loading">Izmeni</p>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import { financesInstance } from '@/axios/axios.js';

export default {
  data() {
    return {
      errorOccurred: false,
      errorMessage: '',
      payoutName: '',
      payoutAmount: '',
      loading: false
    };
  },
  computed: {
    ...mapState('modal', ['transaction']),
    ...mapState('finances', ['transactions'])
  },
  created() {
    document.addEventListener('keydown', this.processKeyboardEvent);
    this.payoutAmount = -this.transaction.amount * 100;
  },
  destroyed() {
    document.removeEventListener('keydown', this.processKeyboardEvent);
  },

  methods: {
    ...mapMutations('modal', ['closeModal']),
    ...mapMutations('table', ['setTableData']),
    ...mapActions('finances', ['getTableData']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    getTodayDateFormatted() {
      let todayDate = new Date().toISOString();
      let dateYear = todayDate.split('T')[0];
      let dateHour = todayDate.split('T')[1].split('.')[0];
      return dateYear + ' ' + dateHour;
    },
    edit() {
      this.errorOccurred = false;
      if (this.doesErrorExist()) {
        this.errorMessage = 'Neispravan unos podataka';
        this.errorOccurred = true;
        return;
      }
      this.loading = true;
      financesInstance
        .put(
          `/communities/${
            this.$store.getters.getActiveCommunity.community_id
          }/transactions/${this.transaction.tid}`,
          {
            description: this.transaction.description,
            amount: -this.payoutAmount,
            timestamp: this.getTodayDateFormatted()
          }
        )
        .then(async () => {
          await this.getTableData({
            communityId: this.$store.getters.getActiveCommunity.id,
            tableName: 'transactions'
          });
          this.setTableData(this.transactions.data);
          this.loading = false;
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(error => {
          this.loading = false;
          this.showFailModal();
        });
    },
    processKeyboardEvent(e) {
      if (e.key === 'Escape') {
        this.closeModal();
      } else if (e.key === 'Enter') {
        this.save();
      }
    },
    doesErrorExist() {
      return this.areFieldsEmpty() || this.numberFieldContainsLetters();
    },
    areFieldsEmpty() {
      return this.transaction.description === '' || this.payoutAmount === '';
    },
    numberFieldContainsLetters() {
      return this.payoutAmount.toString().match(/[a-zA-Z]/g) == true;
    }
  }
};
</script>

<style lang="scss" scoped>
.body {
  padding: 2rem 0;
}

hr {
  margin-top: 0;
}

.input-wrapper {
  display: flex;
  width: 100%;
  justify-content: space-between;
  position: relative;
}

.name--mod {
  width: 60%;
}

.input-span {
  position: absolute;
  font-size: 1.5rem;
  color: rgb(95, 95, 95);
  top: 0.5rem;
  pointer-events: none;
  transition: 0.2s all;
}

.input-span--name {
  left: 1rem;
}

.input-span--amount {
  left: 1rem;
}

input[type='number'] {
  -moz-appearance: textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input {
  margin-right: 15px;
}

.input--name:focus ~ .input-span--name,
.input--name:not(:placeholder-shown) ~ .input-span--name {
  transform: scale(0.75) translateY(-50px) translateX(-30px);
  // opacity: 0;
}

.input--amount:focus ~ .input-span--amount,
.input--amount:not(:placeholder-shown) ~ .input-span--amount {
  transform: scale(0.75) translateY(-50px) translateX(-30px);
}

.relative {
  position: relative;
}

.amount--mod {
  width: 30%;
}

.error {
  color: red;
  float: left;
  margin: 0 auto;
  margin-left: 1rem;
  display: flex;
  align-items: center;
}

.footer {
  width: 100%;
  .buttons {
    .btn--mod {
      height: 35px;
      min-width: 75px;
      margin-left: 5px;
      align-self: center;
    }

    button:disabled {
      background-color: var(--primary-color-lighten);
    }
  }
}

.buttons {
  float: right;
}
</style>
